import type React from 'react'

interface LabelProps {
  name: string
  value: string
}

const Label: React.FC<LabelProps> = ({ name, value }) => (
  <label className="mb-2 block text-sm font-medium uppercase text-primary">
    <span>{name}: </span>
    <span className={value ? '' : 'text-primary/50'}>
      {value || 'No selection'}
    </span>
  </label>
)

export default Label
